var data = {
	v: "5.5.2",
	nm: "Icon-Wrong",
	ddd: 0,
	assets: [
	],
	w: 300,
	h: 300,
	ip: 0,
	op: 270,
	fr: 100,
	fonts: {
		list: [
		]
	},
	layers: [
		{
			ty: 4,
			st: 0,
			ip: 0,
			op: 270,
			ks: {
				a: {
					a: 0,
					k: [
						35.5779,
						35
					]
				},
				p: {
					a: 0,
					k: [
						150.642057,
						153.409912
					]
				},
				s: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								150,
								150
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								236.34,
								236.34
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0.42,
								y: 0
							}
						},
						{
							t: 40,
							s: [
								206.7468,
								206.7468
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 60,
							s: [
								222.7231,
								222.7231
							],
							i: {
								x: 0.58,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 80,
							s: [
								206.7468,
								206.7468
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				},
				o: {
					a: 1,
					k: [
						{
							t: 0,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 20,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						},
						{
							t: 60,
							s: [
								100
							],
							i: {
								x: 1,
								y: 1
							},
							o: {
								x: 0,
								y: 0
							}
						}
					]
				}
			},
			shapes: [
				{
					ty: "gr",
					it: [
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															54.9058,
															62.2642
														],
														[
															64.9058,
															52.2642
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: false
												}
											}
										},
										{
											ty: "st",
											o: {
												a: 0,
												k: 100
											},
											w: {
												a: 0,
												k: 2
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											},
											lj: 1,
											ml: 4,
											d: [
												{
													n: "o",
													nm: "offset",
													v: {
														a: 0,
														k: 0
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													59.9058,
													57.264198
												]
											},
											p: {
												a: 0,
												k: [
													59.9058,
													57.264198
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															54.9058,
															52.2642
														],
														[
															64.9058,
															62.2642
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: false
												}
											}
										},
										{
											ty: "st",
											o: {
												a: 0,
												k: 100
											},
											w: {
												a: 0,
												k: 2
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											},
											lj: 1,
											ml: 4,
											d: [
												{
													n: "o",
													nm: "offset",
													v: {
														a: 0,
														k: 0
													}
												}
											]
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													59.9058,
													57.264198
												]
											},
											p: {
												a: 0,
												k: [
													59.9058,
													57.264198
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													22.5,
													22.5
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.85098,
													0.003922,
													0.003922
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0,
													-2e-6
												]
											},
											p: {
												a: 0,
												k: [
													59.9058,
													57.264198
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											59.9058,
											57.264198
										]
									},
									p: {
										a: 0,
										k: [
											59.65556,
											61.727869
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													2,
													3
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.996078,
													0.976471,
													0.976471
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											p: {
												a: 0,
												k: [
													46,
													23.5
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													3.96226,
													6.60378
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.129412,
													0.137255,
													0.184314
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0.000003,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													45.566103,
													25.754801
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													9.24528,
													11.8868
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													0.000004,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													45.566004,
													25.754701
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													2,
													3
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.996078,
													0.976471,
													0.976471
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											p: {
												a: 0,
												k: [
													25,
													23.5
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													3.96226,
													6.60378
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0.129412,
													0.137255,
													0.184314
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													-1e-6,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													24.433799,
													25.754801
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													9.24528,
													11.8868
												]
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													1,
													1,
													1
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													-1e-6,
													0.000001
												]
											},
											p: {
												a: 0,
												k: [
													24.434199,
													25.754701
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											35.000102,
											25.7547
										]
									},
									p: {
										a: 0,
										k: [
											35.000102,
											25.7547
										]
									},
									s: {
										a: 1,
										k: [
											{
												t: 0,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 150,
												s: [
													100,
													100
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 160,
												s: [
													100,
													0
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 170,
												s: [
													100,
													100
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 180,
												s: [
													100,
													0
												],
												i: {
													x: 0.58,
													y: 1
												},
												o: {
													x: 0.42,
													y: 0
												}
											},
											{
												t: 190,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											},
											{
												t: 200,
												s: [
													100,
													100
												],
												i: {
													x: 1,
													y: 1
												},
												o: {
													x: 0,
													y: 0
												}
											}
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													15.84906,
													19.81132
												]
											}
										},
										{
											ty: "gf",
											o: {
												a: 0,
												k: 100
											},
											s: {
												a: 0,
												k: [
													0,
													0
												]
											},
											e: {
												a: 0,
												k: [
													0,
													9.90566
												]
											},
											g: {
												p: 2,
												k: {
													a: 0,
													k: [
														0,
														0.717647,
														0.011765,
														0.011765,
														1,
														0.85098,
														0.003922,
														0.003922,
														0,
														1,
														1,
														0
													]
												}
											},
											t: 2
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													-18.4906,
													-38.9622
												]
											},
											p: {
												a: 0,
												k: [
													16.0687,
													-4.09694
												]
											},
											r: {
												a: 0,
												k: 22.1687
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "el",
											p: {
												a: 0,
												k: [
													0,
													0
												]
											},
											s: {
												a: 0,
												k: [
													15.84906,
													19.81132
												]
											}
										},
										{
											ty: "gf",
											o: {
												a: 0,
												k: 100
											},
											s: {
												a: 0,
												k: [
													0,
													0
												]
											},
											e: {
												a: 0,
												k: [
													0,
													9.90566
												]
											},
											g: {
												p: 2,
												k: {
													a: 0,
													k: [
														0,
														0.717647,
														0.011765,
														0.011765,
														1,
														0.85098,
														0.003922,
														0.003922,
														0,
														1,
														1,
														0
													]
												}
											},
											t: 2
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													-52.83,
													-38.9623
												]
											},
											p: {
												a: 0,
												k: [
													-11.0017,
													23.6463
												]
											},
											r: {
												a: 0,
												k: -22.916187
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															53.9806,
															7.64283
														],
														[
															54.0016,
															9.05689
														],
														[
															52.5875,
															9.07787
														],
														[
															53.9806,
															7.64283
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0.3847,
															-0.39628
														],
														[
															0.3963,
															0.38468
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.3963,
															0.38469
														],
														[
															-0.3847,
															0.39627
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															40.3856,
															5.48394
														],
														[
															53.9806,
															7.64283
														],
														[
															52.5875,
															9.07787
														],
														[
															41.5011,
															7.14399
														],
														[
															40.3856,
															5.48394
														]
													],
													i: [
														[
															0,
															0
														],
														[
															-5.4425,
															-5.28333
														],
														[
															0,
															0
														],
														[
															1.7086,
															-1.14811
														],
														[
															0,
															0
														]
													],
													o: [
														[
															2.3228,
															-1.56072
														],
														[
															0,
															0
														],
														[
															-4.6274,
															-4.49208
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0,
													0,
													0
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													47.334843,
													6.676144
												]
											},
											p: {
												a: 0,
												k: [
													47.334843,
													6.676144
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															41.4005,
															55.8497
														],
														[
															41.7153,
															54.471
														],
														[
															40.3366,
															54.1561
														],
														[
															41.4005,
															55.8497
														]
													],
													i: [
														[
															0,
															0
														],
														[
															0.2938,
															0.4677
														],
														[
															0.4677,
															-0.2937
														],
														[
															0,
															0
														]
													],
													o: [
														[
															0.4676,
															-0.2938
														],
														[
															-0.2937,
															-0.4677
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															26.994,
															55.5686
														],
														[
															41.4005,
															55.8497
														],
														[
															40.3366,
															54.1561
														],
														[
															28.4015,
															54.1477
														],
														[
															26.994,
															55.5686
														]
													],
													i: [
														[
															0,
															0
														],
														[
															-6.8129,
															4.2795
														],
														[
															0,
															0
														],
														[
															1.441,
															1.4274
														],
														[
															0,
															0
														]
													],
													o: [
														[
															2.0261,
															2.0068
														],
														[
															0,
															0
														],
														[
															-5.9393,
															3.7309
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0,
													0,
													0
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													34.431328,
													56.09013
												]
											},
											p: {
												a: 0,
												k: [
													34.431328,
													56.09013
												]
											}
										}
									]
								},
								{
									ty: "gr",
									it: [
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															17.87,
															7.33684
														],
														[
															17.7228,
															8.74337
														],
														[
															19.1293,
															8.89063
														],
														[
															17.87,
															7.33684
														]
													],
													i: [
														[
															0,
															0
														],
														[
															-0.3478,
															-0.42907
														],
														[
															-0.4291,
															0.34774
														],
														[
															0,
															0
														]
													],
													o: [
														[
															-0.429,
															0.34774
														],
														[
															0.3477,
															0.42906
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "sh",
											ks: {
												a: 0,
												k: {
													v: [
														[
															32.2062,
															5.88824
														],
														[
															17.87,
															7.33684
														],
														[
															19.1293,
															8.89063
														],
														[
															30.9793,
															7.46772
														],
														[
															32.2062,
															5.88824
														]
													],
													i: [
														[
															0,
															0
														],
														[
															6.2505,
															-5.06566
														],
														[
															0,
															0
														],
														[
															-1.6018,
															-1.24426
														],
														[
															0,
															0
														]
													],
													o: [
														[
															-2.2521,
															-1.74935
														],
														[
															0,
															0
														],
														[
															5.4491,
															-4.4162
														],
														[
															0,
															0
														],
														[
															0,
															0
														]
													],
													c: true
												}
											}
										},
										{
											ty: "fl",
											o: {
												a: 0,
												k: 100
											},
											c: {
												a: 0,
												k: [
													0,
													0,
													0
												]
											}
										},
										{
											ty: "tr",
											o: {
												a: 0,
												k: 100
											},
											a: {
												a: 0,
												k: [
													24.852915,
													6.584145
												]
											},
											p: {
												a: 0,
												k: [
													24.852915,
													6.584145
												]
											}
										}
									]
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									a: {
										a: 0,
										k: [
											35.700177,
											31.084703
										]
									},
									p: {
										a: 0,
										k: [
											35.700177,
											31.084703
										]
									}
								}
							]
						},
						{
							ty: "gr",
							it: [
								{
									ty: "el",
									p: {
										a: 0,
										k: [
											0,
											0
										]
									},
									s: {
										a: 0,
										k: [
											70,
											70
										]
									}
								},
								{
									ty: "gf",
									o: {
										a: 0,
										k: 100
									},
									s: {
										a: 0,
										k: [
											-11.8868,
											-31.69811
										]
									},
									e: {
										a: 0,
										k: [
											4.6226,
											35
										]
									},
									g: {
										p: 2,
										k: {
											a: 0,
											k: [
												0,
												1,
												0.768627,
												0.768627,
												1,
												0.988235,
												0.462745,
												0.462745
											]
										}
									},
									t: 1
								},
								{
									ty: "tr",
									o: {
										a: 0,
										k: 100
									},
									p: {
										a: 0,
										k: [
											35,
											35
										]
									}
								}
							]
						},
						{
							ty: "tr",
							o: {
								a: 0,
								k: 100
							}
						}
					]
				}
			]
		}
	]
};

export { data as default };
//# sourceMappingURL=smiley.incorrect.json.js.map
